import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["delay", "locationId", "fields", "closeDelay", "type", "className", "businessId", "businessType", "tags", "event"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useState, useEffect } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { EmailCaptureButtonPropType, EmailCaptureFieldsPropType, EmailCaptureImagePropType, EmailCaptureTypePropType } from './EmailCapture.propTypes';
import { createContact, getErrors } from './EmailCapture.utils';
import VariantMap from './EmailCapture.variants';
import { setFormAsSubmitted, formWasSubmitted } from './utils/storageUtils';
import { ActionName } from '../../components/RecaptchaProvider/RecaptchaProvider.constants';
import { useRecaptcha } from '../../components/RecaptchaProvider/RecaptchaProvider.hooks';
import { EVENT_ACTIONS, EVENT_CATEGORIES } from '../../modules/analytics/components/Event';
import { EventPropType } from '../../modules/analytics/types';
import { GoogleAnalytics } from '../../services/analytics';
import './EmailCapture.css';
export default function EmailCapture(_ref) {
  var delay = _ref.delay,
    locationId = _ref.locationId,
    fields = _ref.fields,
    closeDelay = _ref.closeDelay,
    type = _ref.type,
    className = _ref.className,
    businessId = _ref.businessId,
    businessType = _ref.businessType,
    tags = _ref.tags,
    event = _ref.event,
    rest = _objectWithoutProperties(_ref, _excluded);
  var defaultIsVisible = Number.isInteger(delay) && delay >= 0;
  var _useState = useState(defaultIsVisible),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmitting = _useState4[0],
    setIsSubmitting = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isTouched = _useState6[0],
    setIsTouched = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSuccess = _useState8[0],
    setIsSuccess = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    formData = _useState10[0],
    setFormData = _useState10[1];
  var _useState11 = useState({}),
    _useState12 = _slicedToArray(_useState11, 2),
    errors = _useState12[0],
    setErrors = _useState12[1];
  var _useRecaptcha = useRecaptcha(),
    _useRecaptcha2 = _slicedToArray(_useRecaptcha, 1),
    executeRecaptcha = _useRecaptcha2[0];
  useEffect(function () {
    // If it hasn't been submitted, then display it
    if (!formWasSubmitted(locationId) && isVisible) {
      setIsVisible(true);
    }
  }, []);
  function closeEmailCapture() {
    var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    setTimeout(function () {
      setFormData({});
      setIsVisible(false);
    }, ms);
  }
  function clearError(key) {
    setErrors(function (previousErrors) {
      var newErrors = _objectSpread({}, previousErrors);
      delete newErrors[key];
      return newErrors;
    });
  }
  function formOnSuccess() {
    setIsSubmitting(false);
    setIsSuccess(true);
    setFormData({});
    setFormAsSubmitted(locationId);
    closeEmailCapture(closeDelay * 1000);
  }
  function submitForm(_x) {
    return _submitForm.apply(this, arguments);
  }
  function _submitForm() {
    _submitForm = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(jsEvent) {
      var currentErrors, token, category, _error$response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            jsEvent.stopPropagation();
            if (!isSubmitting) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            currentErrors = getErrors(fields, formData);
            setErrors(currentErrors);
            if (_isEmpty(currentErrors)) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            setIsSubmitting(true);
            _context.next = 10;
            return executeRecaptcha(ActionName.SUBMIT_SUBSCRIBE_FORM);
          case 10:
            token = _context.sent;
            formData.location = locationId;
            formData.action = ActionName.SUBMIT_SUBSCRIBE_FORM;
            formData.tags = tags;
            _context.prev = 14;
            _context.next = 17;
            return createContact(businessId, businessType, locationId, token, formData);
          case 17:
            formOnSuccess();
            category = _get(event, 'category', EVENT_CATEGORIES.CONTACT_EVENT_CATEGORY);
            GoogleAnalytics.event({
              category: category,
              action: EVENT_ACTIONS.CONTACT_SUBMIT_INQUIRY_EVENT_ACTION
            });
            _context.next = 25;
            break;
          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](14);
            if (((_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 409) {
              formOnSuccess();
            } else {
              setIsSubmitting(false);
            }
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[14, 22]]);
    }));
    return _submitForm.apply(this, arguments);
  }
  function updateFormFields(key, _ref2) {
    var target = _ref2.target;
    setFormData(function (previousFormData) {
      return _objectSpread(_objectSpread({}, previousFormData), _defineProperty({}, key, target.value));
    });
    if (!isTouched) {
      setIsTouched(true);
      var category = _get(event, 'category', EVENT_CATEGORIES.CONTACT_EVENT_CATEGORY);
      GoogleAnalytics.event({
        category: category,
        action: EVENT_ACTIONS.CONTACT_FILL_FORM_EVENT_ACTION,
        label: _get(event, 'label') || _get(rest, 'headerText')
      });
    }
    clearError(key);
  }
  var Body = VariantMap[type];
  return /*#__PURE__*/React.createElement("div", {
    className: "fc-email-capture".concat(className ? " ".concat(className) : '')
  }, /*#__PURE__*/React.createElement(Body, _extends({
    type: type,
    submitForm: submitForm,
    closeEmailCapture: closeEmailCapture,
    updateFormFields: updateFormFields,
    isVisible: isVisible,
    isSubmitting: isSubmitting,
    formFieldValues: formData,
    isSuccess: isSuccess,
    errors: errors,
    fields: fields,
    locationId: locationId
  }, rest)));
}
EmailCapture.defaultProps = {
  type: 'inline',
  headerText: 'Join our Mailing List',
  subheaderText: '',
  description: '',
  descriptionTextColor: 'black',
  textColor: 'black',
  bgColor: 'white',
  delay: 2,
  closeDelay: 4,
  className: '',
  image: null,
  darkCloseBtn: true,
  button: {
    label: 'Continue',
    key: 'clickme',
    primary: true,
    bgColor: '',
    textColor: ''
  },
  fields: [{
    label: 'Email',
    key: 'email'
  }],
  tags: [],
  event: null
};